import classNames from 'classnames/bind';
import styles from './Tabs.module.css';
import { ReactNode, useEffect, useRef, useState } from 'react';

interface Tabs {
  list: string[];
  activeIdx?: number;
  onChange: (i: number) => void;
  children: ReactNode;
}

export default function Tabs({ list, activeIdx, onChange, children }: Tabs) {
  const cx = classNames.bind(styles);
  const [activeTab, setActiveTab] = useState(list[activeIdx ?? 0]);

  const btnRef = useRef<HTMLButtonElement>(null);

  const selectTab = (name: string, i: number) => {
    setActiveTab(name);
    onChange(i);
    btnRef.current?.scrollIntoView({
      behavior: 'smooth',
    });
  };

  useEffect(() => {
    setActiveTab(list[activeIdx ?? 0]);
  }, [activeIdx]);

  return (
    <div className={cx('tab_container')}>
      <div className={cx('tab_menu_area')}>
        {list.map((name, i) => (
          <button
            key={name}
            className={cx('btn', 'tab_menu', { on: name === activeTab })}
            onClick={() => selectTab(name, i)}
            ref={btnRef}
          >
            <span>{name}</span>
          </button>
        ))}
      </div>
      <div className={cx('inner')}>{children}</div>
    </div>
  );
}
